export interface IInventoryTemplateEquipment {
  equipmentKeyId: number;
  inventoryTemplateId: string;
  // Populated server-side by InventoryTemplateController.GetInventoryTemplateById
  // from the Viewpoint equipment master so the multiselect chip can render the
  // related-equipment name/description even when the equipment belongs to a
  // company the current user can't see in the /api/Equipment options cache.
  name?: string;
  description?: string;
}
